import { routersPath } from '@router/routes-path'
import { useNavigate } from 'react-router-dom'
import usePermissions from '@hooks/usePermissions'
import { EUserRoles } from '@enums/roles'

export const useRedirect = () => {
  const navigate = useNavigate()
  const permission = usePermissions([EUserRoles.BOSS, EUserRoles.SUPER_ADMIN])

  const userRedirect = (id: string) => {
    permission &&
      navigate(routersPath.USER, {
        state: {
          userId: id,
        },
      })
  }

  const crmRedirect = (id: string, crmName?: string) => {
    permission &&
      navigate(routersPath.CRM_STAT, {
        state: {
          crmId: id,
          crmName,
        },
      })
  }

  const reportRedirect = (id: string) => {
    navigate(routersPath.REPORT, {
      state: {
        reportId: id,
      },
    })
  }

  return { userRedirect, crmRedirect, reportRedirect }
}
